import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { DialogTitle, type DialogTitleProps } from 'base-ui'

export const DialogTitleWrapper: FC<DialogTitleProps> = (props) => {
  const intl = useIntl()

  const { children, ...rest } = props

  return (
    <DialogTitle
      {...rest}
      slotProps={{
        closeButton: {
          'aria-label': intl.formatMessage({
            id: 'general.link.label.close',
          }),
        },
      }}
    >
      {children}
    </DialogTitle>
  )
}
